import { ROOM_UNSPECIFIED } from '@/constants/room-manager'
import { GuestRoomAssignStatusResponseType } from '@/models/room-manager/response/guest-room-assign-status'

// 「指定なし」は未割り当ての予約の置き場で、表には行を出さない（右側の一覧に出す）
export const listRowRoomNumbers = (rooms: GuestRoomAssignStatusResponseType['guestRoomAssignStatusList'][string]): string[] =>
  Object.values(rooms)
    .sort((a, b) => a.displayOrder - b.displayOrder)
    .map(room => room.roomNumber)
    .filter(roomNumber => roomNumber !== ROOM_UNSPECIFIED)
